

























































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import { Job } from '@/models/jobs/job';
import QuestionnaireSection from './QuestionnaireSection.vue';
import Referrals from './../Referrals.vue';
import ReferralProgramusd from './../SvgIcons/ReferralProgramusd.vue';
import ReferralProgramgbp from './../SvgIcons/ReferralProgramgbp.vue';
import JobMainInfo from '@/components/Commons/JobMainInfo.vue';
import {
  SURVEY_DETAILS_SUCCESS_MESSAGE,
  SURVEY_QUESTION_CODE_TEXT,
  SURVEY_QUESTION_CODE_MULTIPLE_CHOICE,
  SURVEY_QUESTION_CODE_RADIO,
  SURVEY_QUESTION_CODE_RATING,
  SURVEY_FEEDBACK_QUESTION_CODE_TEXT,
  SURVEY_QUESTION_CODE_DROPDOWN,

} from '../Survey/SurveyConstants';
import { QuestionResponseData } from '../../models/jobs/questionnaireresponse';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import { WorkFlowStepSubmitRequest } from './../MyJobs/JobListing/JobSubmitFLow';
import {InterviewAppointmentReject} from './../MyJobs/JobListing/JobSubmitFLow'
import RejectInterviewSlotModal from '../Commons/RejectInterviewSlotModal.vue';
import { 
  JOBPOSTING_ASSIGNMENT_STATUS_INTERVIEW,
  APPLICATION_ALERT_STATUS_TEXT,
  APPLICATION_STATUS
} from './../MyJobs/MyJobsConstants';

import {
  QuestionnaireResponse,QuestionnaireDetailRequest,
  UserQuestionResponse
} from '../../models/jobs/questionnaireresponse';
Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});

@Component({
  name: 'MyJobIntermediateStep',
  components: {
    JobMainInfo,
    QuestionnaireSection,
    Referrals,
    ReferralProgramusd,
    ReferralProgramgbp,
    RejectInterviewSlotModal
      },
})
export default class MyJobIntermediateStep extends Vue {
  private distance: number = 0;
  $moment: any;
  public $wlToastr: any;
  public jobDetail_: any[] = [];
  public MEETING_STATUS_INVITE_RECEIVED = 'INVITE RECEIVED';
  public WORLFLOW_STEP_ACTION_CODE_SCHEDULING = '01';
  public questions: any[] = [];

  public allMandatoryQuestionAnswered: boolean = false;
  public schedulingSlotAnswered: boolean = false;
  public answeredQuestions: any[] = [];
  public answeredQuestions_response: any[] = [];
  public listcheck: any[]=["test 1","test2"]
  public enableSubmitButton;
  public stepActions:any=[]
  public panel:any=[]
  public bool:any= []
  public onRejectInterviewClick:boolean=false;
  public onShowReasonCodes:boolean=true;
  public reasonCodeId=-1;
  public comment :string=""
  public reasonCodes :any = []
  public interviewManagementRound: boolean =false;
  public isBranchedQuestionnaire: boolean = false;
  public questionTemplateId :string='';
  private branchedQuestionnaireAnswers :any = []
  private branchedQuestionnaireId = 0
  private hasAnsweredAllBranchedQuestions:boolean = false;

  private selectedSlot = {
    actionCode: -1,
    slot: {
      scheduleSequence: -1,
      appointmentId: -1,
    },
  };
  public interviewSlots:any=[];
  public interviewSlot ={
    actionCode: -1,
    slot: {
      scheduleSequence: -1,
      appointmentId: -1,
    },
  }

  public interviewSlotAnswered:boolean =false;
  private bookmarks: any[] = [];
  private isExpandedJob: boolean = false;

  private showSubmitButton: boolean = true;

  public isRoundsSelected:any=[]
  public rejectInterviewSlot :any ='';

  get isInterviewManagment(){
      return vxm.configs.getGlobalConfigValue('INTERVIEW_CODE_MANAGEMENT');
  }

  test(index){
    if(this.panel[index]){
      this.panel[index]=false
    }
    else 
    this.panel[index]=true

  }

  submitBranchedQuestionnaire(){
    console.log("branched questionnaire id",this.hasAnsweredAllBranchedQuestions)

    let questionnaireDetailRequset :  QuestionnaireDetailRequest = new QuestionnaireDetailRequest();
  questionnaireDetailRequset.companyCode = vxm.jobs.CompanyInfo.companyId;
  questionnaireDetailRequset.questionnaireInfo.userId = vxm.users.myUserProfile.userId;
  questionnaireDetailRequset.questionnaireInfo.jobPostingId = this.$route.params.JobID;
  questionnaireDetailRequset.questionnaireInfo.questionResponseData = this.branchedQuestionnaireAnswers;
  questionnaireDetailRequset.questionnaireInfo.referralCode= "";
  questionnaireDetailRequset.questionnaireInfo.questionTemplateId = this.questionTemplateId;
  if(!this.hasAnsweredAllBranchedQuestions){
    questionnaireDetailRequset.hasAnsweredAll = true;
    questionnaireDetailRequset.navigation = "next";
    questionnaireDetailRequset.currentQuestionId = this.branchedQuestionnaireId;
    questionnaireDetailRequset.questionnaireInfo.questionResponseData = this.branchedQuestionnaireAnswers;
  

  this.$modal.show('survey-spinner');
  let respPromise1 = vxm.jobs.getBranchedQuestionaireListing(questionnaireDetailRequset);
  Promise.all([respPromise1]).then(
        (supportResp) => {
          console.log(supportResp,"this is support resp")
        }
      );      
  }
}

  isPanelOpen(index,event){
    var rejectButton = true;
    if(event.target.closest('.scheduleSectionHeaderText') !=null && event.target.closest('.reject') == null){
      rejectButton = false;
    this.$set(this.panel, index, !this.panel[index]);
    }
    if(rejectButton){
    for(var i=0;i<this.panel.length;i++){
      if(i != index){
        this.$set(this.panel, i, false);

      }
    }
    }
  }
  clickToClose() {
    this.onRejectInterviewClick = false;
    
    // this.intermidateJobId = null;
    // if (!this.inOfferRefused) {
    //   this.comment = '';
    //   this.reasonCodeId = -1;
    // }
  }
  toggleDiv(index) {
    this.panel[index] = !this.panel[index];

    this.$set(this.bool, index, !this.bool[index]);
  }

  async mounted() {
    vxm.jobs.setJobApplicationWorkflowSteps({});
    this.schedulingSlotAnswered = false;
    const jobid = this.$route.params.JobID;
    vxm.jobs.setJobID(parseInt(jobid));
    this.jobDetail_ = vxm.jobs.Job;
    this.distance =
      this.jobDetail_ && this.jobDetail_.length > 0
        ? this.jobDetail_[0].distance
        : 0.0;
    await vxm.jobs.getNewJobApplicationWorkflowSteps(jobid);
    setTimeout(() => {
      if(this.isInterviewManagment) {
	    this.setInterviewSlotsV2(this.meetings);
      } else {
        var stepActions = this.workflowStepActions;
        this.setInterviewSlots(stepActions);
      }
      
      this.interviewManagaementReasonCodes;
    }, 2000);
 
   

  }
  
  acceptInterviewRoundCheck(interview, index) {
    if(!(this.interviewSlots[index] && interview)) {
      this.$wlToastr(
        'error',
        'Something Went Wrong.',
      );
      return;
    }
      
    let request = {
      actionCode: this.WORLFLOW_STEP_ACTION_CODE_SCHEDULING,
      jobPostingID: this.jobDetail_[0].jobPostingId,
      scheduleSelected: {
        interviewTypeMasterDataDetailId: interview.interviewTypeMasterDataDetailId,
        jobPostingAssignmentId: interview.jobPostingAssignmentId,
        appointmentDefinitionId: this.interviewSlots[index].slot.appointmentDefinitionId,
        appointmentId: this.interviewSlots[index].slot.appointmentId,
        scheduleSequence: this.interviewSlots[index].slot.scheduleSequence,
        scheduleStartDTTM: this.interviewSlots[index].slot.scheduleStartDTTM,
        scheduleEndDTTM: this.interviewSlots[index].slot.scheduleEndDTTM,
        //workFlowStatus: vxm.jobs.jobApplicationWorkflowSteps.step,
      }
    };

    vxm.jobs.acceptInterviewAppointmentSlot(request).then(
    (resp) => {
      if (resp.data.success && !resp.data.errorCode) {
        this.rejectInterviewSlot = '';
        this.comment = '';
        this.reasonCodeId = -1;
        this.onRejectInterviewClick = false;
        vxm.users.Rudderstack.trackEvent("Job Accepted", {
          JobPostingId: vxm.jobs.jobId,
          
        })
        this.$wlToastr('success', 'Interview Slot Accepted', '');
        this.$router.push({ name: 'Findjobs' });
      } else {
        this.$wlToastr(
          'error',
          'Something Went Wrong.',
          'Schedule Interview Submission',
        );
      }
    },
    (err) => {
      this.$wlToastr(
        'error',
        'Something Went Wrong.' + err,
        'Schedule Interview Submission',
      );
      console.log(err);
    },
    );
    
  }
  rejectInterviewRoundCheck(interviews){
    this.rejectInterviewSlot = interviews
    if(this.reasonCodes.length>0){
      this.onRejectInterviewClick=true
      return
    }
    else{
      this.$modal.show(
            RejectInterviewSlotModal,
            
            {
              header: 'Alert',
              body: this.$t('MyJobIntermediateStep_AreYouSure'),
              hideOkButton: true,
              onOk: this.submitInterviewRejection,
              okText: 'Confirm',

            },
            {
              height: 'auto',
              clickToClose: false,
            },
          );
    }

  }
  submitInterviewRejection() {
    this.rejectInterviewRound(this.rejectInterviewSlot);
  }
  fomatDate(slots) {
    var interviewSlots = {};

    for (var i = 0; i < slots.length; i++) {
      var slotDetails = slots[i];

      const ScheduleStartDttm =  slotDetails.scheduleStartDTTM.split('T')
      const finalstartdttm = ScheduleStartDttm[0]+" "+ScheduleStartDttm[1].replace('-',":").split('-')[0]

      const gmtTimeZoneStartDate = new Date(finalstartdttm + " GMT");
      const dateKey = this.$moment(gmtTimeZoneStartDate).format('DD-MMM-YYYY');

      if (interviewSlots[dateKey]) {
        interviewSlots[dateKey].push(slotDetails);
      } else {
        interviewSlots[dateKey] = [slotDetails];
      }
    }
    return interviewSlots;
  }

  get disableSubmitBtn() {
    return !(this.allMandatoryQuestionAnswered && this.schedulingSlotAnswered);
  }

  get JobAdminComment(): string {
    return vxm.jobs.JobAdminMessage;
  }

  get showMessage(): string {
    let job_: any = vxm.jobs.Job[0];
    const statusText = this.getJobPostingAssignmentAlertStatusText(job_);
    if (
      job_.awaitingActionBy &&
      job_.awaitingActionBy === '01' &&
      job_.nextStepScheduleStartDTTM
    ) {
      var n = job_.nextStepScheduleStartDTTM.substring(job_.nextStepScheduleStartDTTM.indexOf('T'));
      var res = n.replace(/-/g, ':');
      job_.nextStepScheduleStartDTTM = job_.nextStepScheduleStartDTTM.replace(n, res);

      const startDTTM = new Date(job_.nextStepScheduleStartDTTM);
      const dateString = this.$moment(startDTTM).format('DD-MMM-YYYY');
      const timeStampString = this.$moment(startDTTM).format('hh:mm A');
      return job_.jobPostingAssignmentStatus === JOBPOSTING_ASSIGNMENT_STATUS_INTERVIEW
        ? `Your interview is scheduled on ${dateString} at ${timeStampString}.`
        : `${statusText}, and you’ve been selected for an interview scheduled on ${dateString} at ${timeStampString}.`;
    } else {
      return statusText? `${statusText}.` : '';
    }
  }

  isRoundScheduled(slots, index) {
    for (var i = 0; i < slots.length; i++) {
      if (slots[i].status == 1) {
        this.isRoundsSelected[index] = true;
        return true;
      }
    }
    return false;
  }

  displaySlots(scheduleStartDTTM,scheduleEndDTTM){
    const ScheduleStartDttm =  scheduleStartDTTM.split('T')
    const finalstartdttm = ScheduleStartDttm[0]+" "+ScheduleStartDttm[1].replace('-',":").split('-')[0]
    const scheduleEndDttm =  scheduleEndDTTM.split('T')
    const finalEndDttm = scheduleEndDttm[0]+" "+scheduleEndDttm[1].replace('-',":").split('-')[0]
    const gmtTimeZoneStartDate = new Date(finalstartdttm + " GMT");
    const gmtTimeZoneEndDate = new Date(finalEndDttm + " GMT");
    const formattedLocalStartTime = this.$moment(gmtTimeZoneStartDate).format('hh:mm A');
    const formattedLocalEndTime = this.$moment(gmtTimeZoneEndDate).format('hh:mm A');
    return `${formattedLocalStartTime} To ${formattedLocalEndTime}`;
  }

  getSelectedTimeSlot(meeting) {
    return meeting.schedules && meeting.schedules.find((x) => x.appointmentId);
  }

  getScheduleDate(meeting) {
    const schedule = this.getSelectedTimeSlot(meeting);
    if(!schedule) return '';
    
    var n = schedule.scheduleStartDTTM.substring(
      schedule.scheduleStartDTTM.indexOf('T'),
    );
    var res = n.replace(/-/g, ':');
    var scheduleStartDTTM = schedule.scheduleStartDTTM.replace(n, res);

    const startDTTM = new Date(scheduleStartDTTM);
    return this.$moment(startDTTM).format('DD-MMM-YYYY');

  }
  
  getScheduleTime(meeting) {
    const schedule = this.getSelectedTimeSlot(meeting);
    if(!schedule) return '';
    return this.displaySlots(schedule.scheduleStartDTTM, schedule.scheduleEndDTTM);
  }

  getJobPostingAssignmentAlertStatusText(job_): string {
    const translatedStatus = { 
      '20': this.$t('MyJobIntermediateStep_ApplicationScreened').toString(),
      '30': this.$t('MyJobIntermediateStep_SelectedForInterview').toString(),
      '35': this.$t('MyJobIntermediateStep_ApplicationReviewed').toString()
    };
    return translatedStatus[job_.jobPostingAssignmentStatus] ||
    	this.$t(APPLICATION_ALERT_STATUS_TEXT[job_.jobPostingAssignmentStatus]) || '';
  }
  
  dateFormat(date){
    return date.split("T")[0]
  }
 
  selectSlot(slot) {
    this.selectedSlot.slot = slot;
    this.schedulingSlotAnswered = true;
  }

  selectInterviewSlot(slot,index){
    this.interviewManagementRound =true
   if(this.interviewSlots[index] && this.interviewSlots[index].slot.scheduleSequence==-1){
    this.interviewSlots[index].slot= slot
    this.isRoundsSelected[index]=true
   }
   else if(this.interviewSlots[index] && this.interviewSlots[index].slot.scheduleSequence==slot.scheduleSequence){

    this.interviewSlots[index].slot= {
      scheduleSequence: -1,
      appointmentId: -1,
   }
   this.isRoundsSelected[index]=false
  }
   else{
    this.interviewSlots[index].slot= slot
    this.isRoundsSelected[index]=true
    }

   for(var i=0;i<this.interviewSlots.length;i++){
    if(this.interviewSlots[i].slot.appointmentId !=-1){
      this.interviewSlotAnswered=true
      break;
    }
    else{
      this.interviewSlotAnswered=false

    }
   }
  }

  getPayload() {
    let workflowStepActionResponse: any[] = [];

    let scheduleActionId = this.getScheduleActionId();
    if (!this.isInterviewManagment &&  scheduleActionId) {
      workflowStepActionResponse.push({
        actionCode: scheduleActionId,
        jobScheduleId: [this.jobDetail_[0].jobPostingId],
        schedulesSelected: [
          {
            appointmentId: this.selectedSlot.slot.appointmentId,
            scheduleSequence: this.selectedSlot.slot.scheduleSequence,
            scheduleStartDTTM: this.selectedSlot.slot['scheduleStartDTTM'],
            scheduleEndDTTM: this.selectedSlot.slot['scheduleEndDTTM'],
            workFlowStatus: vxm.jobs.jobApplicationWorkflowSteps.step,
          },
        ],
      });
    }
    else if(this.isInterviewManagment && scheduleActionId){
      var schedulesSelected:any=[]
      /*for(var i=0;i<this.interviewSlots.length;i++){
        if(this.interviewSlots[i].slot['appointmentDefinitionId']!=-1){
        schedulesSelected.push(
          {
            appointmentDefinitionId:this.interviewSlots[i].slot['appointmentDefinitionId'],
            appointmentId: this.interviewSlots[i].slot.appointmentId,
            scheduleSequence: this.interviewSlots[i].slot.scheduleSequence,
            scheduleStartDTTM: this.interviewSlots[i].slot['scheduleStartDTTM'],
            scheduleEndDTTM: this.interviewSlots[i].slot['scheduleEndDTTM'],
            workFlowStatus: vxm.jobs.jobApplicationWorkflowSteps.step,
          });
        }
      }*/

      workflowStepActionResponse.push({
        actionCode: scheduleActionId,
        jobScheduleId: [this.jobDetail_[0].jobPostingId],
        schedulesSelected: schedulesSelected
      });
    }


    let questionActionId = this.getQuestionActionId();
    if (questionActionId) {
      let questionResponseData = this.prepareQuestionRequestPayload();
      workflowStepActionResponse.push({
        actionCode: questionActionId,
        jobScheduleId: [this.jobDetail_[0].jobPostingId],
        questionResponseData: questionResponseData,
      });
    }
    let workFlowStepSubmitRequest: WorkFlowStepSubmitRequest = {
      sessionToken: '',
      comment: '',
      offerRefusedReason: NaN,
      offerRefusedPage: '',
      workflowStepUserData: {
        refUrl: '',
        jobPostingID: this.jobDetail_[0].jobPostingId,
        step: vxm.jobs.jobApplicationWorkflowSteps.step,
        jobPostingAssignmentStatus:
          vxm.jobs.jobApplicationWorkflowSteps.jobPostingAssignmentStatus,
        workflowStepActionResponses: workflowStepActionResponse,
        allSlotsSelected:this.allInterviewRoundsSelected
      },
    };
    return workFlowStepSubmitRequest;
  }

  get allInterviewRoundsSelected() {
    for (var i = 0; i < this.isRoundsSelected.length; i++) {
      if (!this.isRoundsSelected[i]) {
        return false;
      }
    }

    return true;
  }
  getScheduleActionId() {
    if (!vxm.jobs.jobApplicationWorkflowSteps.workflowStepActions) {
      return null;
    }
    let questionActionObj = vxm.jobs.jobApplicationWorkflowSteps.workflowStepActions.filter(
      (workflowStepAction) =>
       ( workflowStepAction && workflowStepAction.schedules)||( workflowStepAction && this.isInterviewManagment && workflowStepAction.interviews),
    );

    if (questionActionObj && questionActionObj.length > 0) {
      return questionActionObj[0]['actionCode'];
    } else {
      return null;
    }
  }

  getQuestionActionId() {
    if (!vxm.jobs.jobApplicationWorkflowSteps.workflowStepActions) {
      return null;
    }
    let questionActionObj = vxm.jobs.jobApplicationWorkflowSteps.workflowStepActions.filter(
      (workflowStepAction) =>
        workflowStepAction && workflowStepAction.questions,
    );
    if (questionActionObj && questionActionObj.length > 0) {
      return questionActionObj[0]['actionCode'];
    } else {
      return null;
    }
  }

  submitCandidateResponse() {
    console.log("submit button clicked..")
    if(this.isBranchedQuestionnaire){
      this.submitBranchedQuestionnaire()
    }
    const payload: WorkFlowStepSubmitRequest = this.getPayload();
    vxm.jobs.submitJobApplyIntermediateFlow(payload).then(
      (resp) => {
        if (!this.interviewManagementRound && resp.data && !resp.data.errorCode) {
          this.$wlToastr(
            'success',
            this.$t('MyJobIntermediateStep_ResponseSaved'),
            this.$t('MyJobIntermediateStep_WorkflowStepSubmission'),
          );
          this.$router.push({ name: 'myjobstatus' });
        }
        else if(this.interviewManagementRound && resp.data && !resp.data.errorCode){
          this.interviewManagementRound=false;
          this.$wlToastr( 'success',
            this.$t('MyJobIntermediateStep_InterviewSlotSelected'),
            this.$t('MyJobIntermediateStep_WorkflowStepSubmission'),
          );
          this.$router.push({ name: 'Findjobs' });
        }
         else {
          this.$wlToastr(
            'error', 
            resp.data.errorMessage,
            this.$t('MyJobIntermediateStep_WorkflowStepSubmission'),
          );
        }
      },
      (err) => {
        this.$wlToastr(
          'error',
          `${this.$t('something.went.wrong')}. ${this.$t('please.try.again')}`,
           this.$t('MyJobIntermediateStep_WorkflowStepSubmission'),
        );
        console.log(err);
      },
    );
  }
  rejectInterviewRound(interview){
    this.clickToClose();
    let interviewAppointmentReject: InterviewAppointmentReject = {
    appointmentDefinitionId: interview.appointmentDefinitionId,  
    interviewTypeMasterDataDetailId: interview.interviewTypeMasterDataDetailId,
    jobPostingAssignmentId: interview.jobPostingAssignmentId,
    userId:vxm.users.myUserProfile.userId,
    appointmentRefusedReason:this.reasonCodeId,
    comment: this.comment

      
      
    }
    vxm.jobs.rejectInterviewAppointmentSlot(interviewAppointmentReject).then(
      (resp) => {
        if (resp.data.success && !resp.data.errorCode) {
     this.rejectInterviewSlot=''
          this.comment=''
    this.reasonCodeId=-1
          this.onRejectInterviewClick = false
          vxm.users.Rudderstack.trackEvent("Job Accepted", {
          JobPostingId: vxm.jobs.jobId,          
        })
          this.$wlToastr(
            'success',
            this.$t('MyJobIntermediateStep_InterviewSlotRejected'),
            this.$t('MyJobIntermediateStep_WorkflowStepSubmission'),
          );
          this.$router.push({ name: 'Findjobs' });
        }
         else {
          this.$wlToastr(
            'error',
            this.$t('something.went.wrong'),
            this.$t('MyJobIntermediateStep_WorkflowStepSubmission'),
          );
        }
      },
      (err) => {
        this.$wlToastr(
          'error',
          this.$t('something.went.wrong'),
          this.$t('MyJobIntermediateStep_WorkflowStepSubmission'),
        );
        console.log(err);
      },
    );

  }

  prepareQuestionRequestPayload(): QuestionResponseData[] {
    let questionResponseData: QuestionResponseData[] = [];
    this.answeredQuestions_response.forEach((question) => {
      let obj = {
        questionID: question.questionID,
        userQuestionResponse: question.userQuestionResponse,
      };
      if (
        (question.questionType === SURVEY_QUESTION_CODE_RADIO ||
          question.questionType === SURVEY_QUESTION_CODE_RATING) &&
        (obj.userQuestionResponse.userAnswerList &&
          !Array.isArray(obj.userQuestionResponse.userAnswerList))
      ) {
        obj.userQuestionResponse.userAnswerList = [
          obj.userQuestionResponse.userAnswerList,
        ];
      }
      if (
        question.questionType === SURVEY_QUESTION_CODE_RADIO ||
        question.questionType === SURVEY_QUESTION_CODE_RATING ||
        question.questionType === SURVEY_QUESTION_CODE_MULTIPLE_CHOICE
      ) {
        delete obj.userQuestionResponse.questionTextResponse;
        delete obj.userQuestionResponse.videoQuestionResponse;
      } else if (
        question.questionType === SURVEY_QUESTION_CODE_TEXT ||
        question.questionType === SURVEY_FEEDBACK_QUESTION_CODE_TEXT
      ) {
        delete obj.userQuestionResponse.userAnswerList;
        delete obj.userQuestionResponse.videoQuestionResponse;
      }
      if (question.status && question.status === '0') {
        obj.userQuestionResponse.questionTextResponse = null;
      }
      if (
        !(
          obj.userQuestionResponse.hasOwnProperty('questionTextResponse') &&
          obj.userQuestionResponse.questionTextResponse === ''
        )
      ) {
        questionResponseData.push(obj);
      }
    });
    return questionResponseData;
  }

  bookmarkJob(job: any) {
    let jobs = this.bookmarks.filter(
      (bookmark) => bookmark.objectId === job.jobPostingId,
    );
    if (jobs && jobs.length > 0) {
      for (let bookmark of this.bookmarks) {
        if (job.jobPostingId == bookmark.objectId) {
          if (job.bookmarkStatus && job.bookmarkStatus === 'A') {
            job.bookmarkStatus = 'D';
            bookmark.action = 'D';
          } else if (job.bookmarkStatus && job.bookmarkStatus === 'D') {
            job.bookmarkStatus = 'A';
            bookmark.action = 'A';
          }
        }
      }
    } else if (job.bookmarkStatus && job.bookmarkStatus === 'A') {
      job.bookmarkStatus = 'D';
      this.bookmarks.push({
        action: 'D',
        type: '01',
        objectId: job.jobPostingId,
      });
    } else if (job.bookmarkStatus && job.bookmarkStatus === 'D') {
      job.bookmarkStatus = 'A';
      this.bookmarks.push({
        action: 'A',
        type: '01',
        objectId: job.jobPostingId,
      });
    }

    let bookmarkIcon = this.$refs['bookmark_' + job.jobPostingId];
    if (job.bookmarkStatus && job.bookmarkStatus === 'A') {
      bookmarkIcon[0].classList = ['fa fa-bookmark secondary-color bookmark-icon'];
    } else if (job.bookmarkStatus && job.bookmarkStatus === 'D') {
      bookmarkIcon[0].classList = [
        'fa fa-bookmark-o remove-color bookmark-icon',
      ];
    }
    let req = {
      sessionToken: '13223',
      bookmarks: this.bookmarks,
    };
    if (this.bookmarks && this.bookmarks.length > 0) {
      vxm.jobs.bookmarkJob(req).then((resp) => {});
    }
  }

  questionnaireAnsweredCallback(event) {
    if(!this.isBranchedQuestionnaire){
    this.answeredQuestions_response = [];
    event.answeredQuestions.forEach((element) => {
      this.answeredQuestions_response.push({ ...element });
    });
    this.allMandatoryQuestionAnswered = event.allMandatoryQuestionAnswered;
  }
  else{
    this.allMandatoryQuestionAnswered = event.allMandatoryQuestionAnswered
    this.branchedQuestionnaireAnswers = event.answeredQuestions
    this.branchedQuestionnaireId = event.branchedQuestionnaireId
    this.hasAnsweredAllBranchedQuestions = event.hasAnsweredAllQuestions

  }
  }

  get JobPostingAssignmentText(): string {
    return APPLICATION_STATUS[vxm.jobs.jobApplicationWorkflowSteps.jobPostingAssignmentStatus] || '';
  }

  formatInterviewData(dates): any{
  }

  formatSchedulesData(schedules): any {
    let schedulesMap = {};
    schedules.forEach((schedule) => {
      var n = schedule.scheduleStartDTTM.substring(
        schedule.scheduleStartDTTM.indexOf('T'),
      );
      var res = n.replace(/-/g, ':');
      var scheduleStartDTTM = schedule.scheduleStartDTTM.replace(n, res);

      const startDTTM = new Date(scheduleStartDTTM);

      n = schedule.scheduleEndDTTM.substring(
        schedule.scheduleEndDTTM.indexOf('T'),
      );
      res = n.replace(/-/g, ':');
      var scheduleEndDTTM = schedule.scheduleEndDTTM.replace(n, res);

      const endDTTM = new Date(scheduleEndDTTM);

      let dateString = this.$moment(startDTTM).format('DD-MMM-YYYY');
      let timeStampString =
        this.$moment(startDTTM).format('h:mm A') +
        ' - ' +
        this.$moment(endDTTM).format('h:mm A');
      if (schedulesMap[dateString]) {
        let tempArr: any[] = schedulesMap[dateString];
        tempArr.push({ ...schedule, timeStampString: timeStampString });
        schedulesMap[dateString] = tempArr;
      } else {
        schedulesMap[dateString] = [
          { ...schedule, timeStampString: timeStampString },
        ];
      }
    });
    return schedulesMap;
  }

  showHeader() {
    const jobID = vxm.jobs.jobId;
    let job_: any = vxm.jobs.Job[0];
    if (!job_) return false;
    const status = this.getJobPostingAssignmentAlertStatusText(job_);
    return typeof status === 'string' && status.length > 0;
  }

  getJobReferralProgramExists(job) {
    if (job.companyReferralIncentive != null) {
      return job.companyReferralIncentive.companyReferralIncentiveName !== 'NA'
        ? true
        : false;
    }
    return false;
  }
  get isBranchedQuestionnairesPresent():any{
    return vxm.jobs.jobApplicationWorkflowSteps.questionareInfo?vxm.jobs.jobApplicationWorkflowSteps.questionareInfo.hasBranchedQuestions:false;
  }
  get workflowStepActions(): any {
    //const hasEnviteReceived = this.meetings.find(x => x.interviewStatus == this.MEETING_STATUS_INVITE_RECEIVED);
    //this.showSubmitButton = vxm.jobs.jobApplicationWorkflowSteps.workflowStepActions || hasEnviteReceived;
    this.showSubmitButton = vxm.jobs.jobApplicationWorkflowSteps.workflowStepActions;
    if(vxm.jobs.jobApplicationWorkflowSteps.questionareInfo){
    this.isBranchedQuestionnaire = vxm.jobs.jobApplicationWorkflowSteps.questionareInfo.hasBranchedQuestions
    
    console.log(vxm.jobs.jobApplicationWorkflowSteps.questionareInfo,"checking is branched questionnaires....")
    this.questionTemplateId = vxm.jobs.jobApplicationWorkflowSteps.questionareInfo.questionTemplateId
    }
    if (!this.getQuestionActionId()) {
      this.allMandatoryQuestionAnswered = true;
    }
    if (!this.getScheduleActionId()) {
      this.schedulingSlotAnswered = true;
    } else {
      this.schedulingSlotAnswered = false;
    }
    let stepActions = vxm.jobs.jobApplicationWorkflowSteps.workflowStepActions
      ? vxm.jobs.jobApplicationWorkflowSteps.workflowStepActions.filter(
          (step) => (step),
        )
      : [];
    return stepActions;
  }

  get meetings() {
    return vxm.jobs.jobApplicationWorkflowSteps.interviews || [];
  }
  get interviewManagaementReasonCodes(): any {
    if (this.isInterviewManagment && vxm.jobs.interviewManagementReasonCodes) {
      this.reasonCodes = vxm.jobs.interviewManagementReasonCodes;

      return vxm.jobs.interviewManagementReasonCodes;
    }
    return null;
  }
  async setInterviewSlots(stepActions){
    if(this.isInterviewManagment && vxm.jobs.jobApplicationWorkflowSteps && vxm.jobs.jobApplicationWorkflowSteps.reasonCodes
    && vxm.jobs.jobApplicationWorkflowSteps.length>0){
      this.reasonCodes=vxm.jobs.jobApplicationWorkflowSteps.reasonCodes
    }

    if (
      this.isInterviewManagment &&
      stepActions[0] &&
      stepActions[0].interviews
    ) {
      for (var i = 0; i < stepActions[0].interviews.length; i++) {
        this.panel.push(false);
        this.isRoundsSelected.push(false);
        this.interviewSlots.push({
          actionCode: -1,
          slot: {
            scheduleSequence: -1,
            appointmentId: -1,
          },
        });
      }
    }
  }
  
  async setInterviewSlotsV2(meetings) {
    if (
      this.isInterviewManagment &&
      vxm.jobs.jobApplicationWorkflowSteps &&
      vxm.jobs.jobApplicationWorkflowSteps.reasonCodes &&
      vxm.jobs.jobApplicationWorkflowSteps.length > 0
    ) {
      this.reasonCodes = vxm.jobs.jobApplicationWorkflowSteps.reasonCodes;
    }

    if (this.isInterviewManagment && meetings && meetings[0]) {
      for (var i = 0; i < meetings.length; i++) {
        this.panel.push(false);
        this.isRoundsSelected.push(false);
        this.interviewSlots.push({
          actionCode: -1,
          slot: {
            scheduleSequence: -1,
            appointmentId: -1,
          },
        });
      }
    }
  }
  get payRateNegotiableText() {
    return vxm.configs.getGlobalConfigValue('NEGOTIABLE_JOB_TEXT');
  }

  setNavigation(path: string) {
    this.$cookies.set('NavigateTo_ID', path, 600);
  }

  bookmarkClass(job) {
    if (job.bookmarkStatus && job.bookmarkStatus === 'A') {
      return 'fa fa-bookmark secondary-color';
    } else {
      return 'fa fa-bookmark-o remove-color';
    }
  }

  parseUrl(videoURL: string): string {
    const nArr = videoURL.split('=');
    return nArr[1];
  }

  goBackRoute() {
    this.$router.go(-1);
  }
  getDistance() {
    if (this.distance > 0.1) {
      return this.distance.toFixed(1);
    } else {
      return '0.1';
    }
  }
  getCompanyDistanceUnits(): string {
    if (vxm.jobs.getCompanyDistanceUnit == 'kilometers') {
      return 'km';
    }
    return 'mi';
  }

  get isLoggedIn(): boolean {
    return vxm.users.isLoggedIn;
  }

  getCompanyLogoUrl(companyCode: string): string {
    return vxm.jobs.getCompanyLogoUrl(companyCode);
  }

  getFirstCapitalletter(value: string): string {
    if (!value) return '';
    value = value.toString();
    return value
      .trim()
      .charAt(0)
      .toUpperCase();
  }
}
